// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2mPGC","title":"BackImages_title__bQnnN","images":"BackImages_images__1IPsj"};